"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestProgressSnapshotToJSON = exports.QuestProgressSnapshotFromJSONTyped = exports.QuestProgressSnapshotFromJSON = void 0;
var _1 = require("./");
function QuestProgressSnapshotFromJSON(json) {
    return QuestProgressSnapshotFromJSONTyped(json, false);
}
exports.QuestProgressSnapshotFromJSON = QuestProgressSnapshotFromJSON;
function QuestProgressSnapshotFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'questConfigId': json['questConfigId'],
        'name': json['name'],
        'milestones': (json['milestones'].map(_1.QuestConfigMilestoneFromJSON)),
        'archives': (json['archives'].map(_1.QuestProgressSnapshotUserFromJSON)),
    };
}
exports.QuestProgressSnapshotFromJSONTyped = QuestProgressSnapshotFromJSONTyped;
function QuestProgressSnapshotToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
        'questConfigId': value.questConfigId,
        'name': value.name,
        'milestones': (value.milestones.map(_1.QuestConfigMilestoneToJSON)),
        'archives': (value.archives.map(_1.QuestProgressSnapshotUserToJSON)),
    };
}
exports.QuestProgressSnapshotToJSON = QuestProgressSnapshotToJSON;
